import React, { useState, useEffect } from 'react';

import { IComponentTextarea } from '../../component.d';
import { RenderRequired } from './Form';

const AllForFormTextarea = function(props: IComponentTextarea) {
  const {
    field,
    align,
    width,
    onChange,
    required,
    placeholder,
    label,
    min,
    max,
    rows,
    type
  } = props;

  const [data, setData] = useState('');

  return (
    <div className="all-for-textarea">
      <div
        className="weui-cells__group weui-cells__group_form"
        style={{ width: `${width}%` }}
      >
        {label ? (
          <div className="weui-cells__title">
            {field} {RenderRequired(required)}
          </div>
        ) : null}
        <div className="weui-cells weui-cells_form">
          <div className="weui-cell ">
            <div className="weui-cell__bd">
              <textarea
                className="weui-textarea"
                placeholder={placeholder}
                rows={rows}
                value={data}
                onChange={e => {
                  let str = e.target.value || '';
                  str = str.substring(0, max);
                  setData(str);
                  onChange(type, field, str);
                }}
              ></textarea>
              <div className="weui-textarea-counter">
                <span>{data.length || 0}</span>/{max}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllForFormTextarea;
